import React, { useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import AddExercises from "../myWorkout/addExercises";
import AddJouralExerciseForm from "./add/addJournalExerciseForm";
import { resetField } from "../../../store/actions";
import JournalTabs from "./journalEntriesTabs";
import "./FitnessJournal.scss";

const FitnessJournalEntries = ({ journalDate, history, resetField, journal, range }) => {
	const [isJournalEntry] = useState(true);
	const [journalExercise, setJournalExercise] = useState(null);

	const addExerciseToJournal = (event) => {
		resetField("MyWorkout.toggleAddPlanPanel", false);
		setJournalExercise(event);
	};

	return (
		<div className="card card-primary p-4 border-0 mt-3 mb-3 tab-primary">
			<div className="d-flex flex-row justify-content-between">
				<h4 className="text-primary-dark"> Journal Entries</h4>
			</div>
			<JournalTabs
				cardioData={"cardioData"}
				resistanceData={"resistanceData"}
				felxibilityData={"felxibilityData"}
				othersData={"othersData"}
				date={journalDate}
				range={range}
			/>
			<div className="fitness-add-journal">
				<AddExercises history={history} isJournalEntry={isJournalEntry} onUpdate={addExerciseToJournal} />
			</div>

			{journalExercise && range && (
				<AddJouralExerciseForm
					journalLogDate={journalDate}
					initialValues={journalExercise}
					onUpdate={() => setJournalExercise(null)}
					range={range}
				/>
			)}
		</div>
	);
};

const mapDispachToProps = { resetField };

const mapStateToProps = (state) => {
	const { MyWorkout } = state;
	return {
		toggleAddPlanPanel: get(MyWorkout, "toggleAddPlanPanel", false),
		fitnessJournal: get(state.FitnessJournal, "fitnessJournal", {})
	};
};

export default connect(
	mapStateToProps,
	mapDispachToProps
)(FitnessJournalEntries);
